<mat-drawer-container class="flex h-full flex-row" autosize [class.use-dark-theme]="false">
    <mat-drawer
        #drawer
        [mode]="'side'"
        [disableClose]="true"
        [opened]="true"
        [class.active]="isExpanded"
        class="mat-elevation-z8 min-w-50 custom-drawer"
    >
        <app-sidebar class="border-left" [(isExpanded)]="isExpanded" (keydown.escape)="backdropClicked()"></app-sidebar>
    </mat-drawer>

    <mat-drawer-content>
        <div class="content-container flex h-full grow flex-col">
            <app-global-warning></app-global-warning>

            <div class="content flex grow flex-col overflow-auto pb-4 pl-5 pr-5 pt-5">
                <router-outlet></router-outlet>
            </div>
        </div>

        <div
            #drawerOverlay
            class="backdropOverlay"
            [class.hide]="!isExpanded"
            [class.show]="isExpanded"
            (click)="isExpanded ? backdropClicked() : ''"
        ></div>
    </mat-drawer-content>
</mat-drawer-container>
